@import (reference) '../../../../../constants/spacing.module.less';

.modal-body {
  padding: @space-24;
}
